module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAd0lEQVR4AWMYHECyi+E/PqzQwfBfqBuIgWzBHob/wkC2DFCMaAPyShj+9xcw/J9awfC/rJTh//Q8hv8h1SQYIAm00aOe4f+8Iob/8zMY/nvVMPyX6sQwgDBWLmP4r1gN45NgwF1VARAGaQDjtzUgPEgMGDVgeAAAVMwGUfE1BesAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ZM.png
// module id = 1307
// module chunks = 0